export class AppContext {
  branchId: string = "0";
}
